import React from 'react';
import { connect } from 'react-redux';
import { Layout, Button, Alert, Skeleton } from 'antd';
import { Service, ServiceGroup } from '../../types/service';
import { User } from '../../types/user';
import { countSelectedServices } from '../../utils/bookingUtil';
import { bookingActions } from '../../actions/booking';
import Services from '../../components/Services';

interface Props {
  // HTML attributes
  id?: string;
  skeleton?: boolean;
  onSelectService?: (service: any) => void;
  isFetchingStylists?: boolean;
  onSelectStylist?: (service: Service) => void;

  isAdmin: boolean;
  users: User[];
  activeUserId: number;
  serviceGroups: ServiceGroup[];
  activeRootCateMobile: string;
  storeActiveRootCateMobile: (cateId: string) => void;
}

class BookingServices extends React.PureComponent<Props> {
  state;
  maxServices: number;

  constructor(props) {
    super(props);

    this.state = {};
    this.maxServices = 2;
  }

  getLimitationMessage() {
    return this.maxServices > 0 ? `Max ${this.maxServices} services per client` : '';
  }

  getActiveUser() {
    const { users, activeUserId } = this.props;
    return users.find(user => user.id === activeUserId);
  }

  onChangeCate(cate: Service) {
    const { storeActiveRootCateMobile } = this.props;
    storeActiveRootCateMobile(cate.key);
  }

  onChangeService(service: Service) {
    const { onSelectService } = this.props;

    if (onSelectService) {
      onSelectService(service);
    }
  }

  onChangeStylist(service: Service) {
    const { onSelectStylist } = this.props;

    if (onSelectStylist) {
      onSelectStylist(service);
    }
  }

  renderMobileContent() {
    const { skeleton, serviceGroups, activeRootCateMobile, isFetchingStylists } = this.props;
    const activeUser = this.getActiveUser() as any;
    const rootGroups = [...serviceGroups].map(cate => {
      const { data, ...withoutData } = cate;
      return {
        ...withoutData,
        itemCount: countSelectedServices(activeUser, cate),
      } as any;
    }) as ServiceGroup[];
    const selectedGroup = [...serviceGroups].find(group => group.key === activeRootCateMobile) || serviceGroups[0];

    return (
      <>
        <Layout.Header className="fave-block--header fave-block--header-mobile">
          <b>Select services</b>
          <span>{this.getLimitationMessage()}</span>
        </Layout.Header>

        <Layout.Content
          className="fave-block--content fave-block--content-mobile"
          style={{ padding: 0 }}
        >
          <div className="booking-services--tabs">
            {skeleton && [1, 2].map(cate => {
              return (
                <Button
                  className="booking-services--button"
                  type={cate === 1 ? 'primary' : 'default'}
                  key={`skeleton-cate-${Math.random()}`}
                  style={{ width: '50%', pointerEvents: 'none' }}
                >
                  <Skeleton.Input />
                </Button>
              );
            })}

            {!skeleton && rootGroups.map((cate: any) => {
              return (
                <Button
                  className="booking-services--button"
                  type={cate.key === selectedGroup.key ? "primary" : undefined}
                  onClick={() => this.onChangeCate(cate)}
                  key={cate.key}
                >
                  <div>{cate.name}</div>
                  {cate.itemCount > 0 && (
                    <div className="item-count">({cate.itemCount} {cate.itemCount > 1 ? 'items' : 'item'})</div>
                  )}
                </Button>
              );
            })}
          </div>

          <div className="booking-services--content">
            <Services
              skeleton={skeleton}
              maxServices={this.maxServices}
              serviceGroups={(selectedGroup && selectedGroup.data) || []}
              isFetchingStylists={isFetchingStylists}
              onChangeService={service => this.onChangeService(service)}
              onChangeStylist={service => this.onChangeStylist(service)}
            />
          </div>
        </Layout.Content>
      </>
    );
  }

  renderDesktopContent() {
    const { skeleton, serviceGroups, isFetchingStylists } = this.props;

    return (
      <>
        <Layout.Header className="fave-block--header fave-block--header-desktop">
          Select services
        </Layout.Header>

        <Layout.Content className="fave-block--content fave-block--content-desktop">
          {!skeleton && this.maxServices > 0 && (
            <Alert
              type="warning"
              style={{ marginBottom: 16 }}
              message={this.getLimitationMessage()}
            />
          )}

          <Services
            skeleton={skeleton}
            maxServices={this.maxServices}
            serviceGroups={serviceGroups || []}
            isFetchingStylists={isFetchingStylists}
            onChangeService={service => this.onChangeService(service)}
            onChangeStylist={service => this.onChangeStylist(service)}
          />
        </Layout.Content>
      </>
    );
  }

  render() {
    const { id } = this.props;
    return (
      <Layout
        id={id}
        className="fave-layout fave-block"
        style={{ position: 'static' }}
      >
        {this.renderMobileContent()}
        {this.renderDesktopContent()}
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  isAdmin: state.salonStore.isAdmin,
  users: state.bookingStore.users,
  activeUserId: state.bookingStore.activeUserId,
  serviceGroups: state.salonStore.serviceGroups,
  activeRootCateMobile: state.bookingStore.activeRootCateMobile,
});
const mapDispatchToProps = dispatch => ({
  storeActiveRootCateMobile: (cateId: string) => dispatch(bookingActions.storeActiveRootCateMobile(cateId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BookingServices);
